import {apolloClient} from 'shared/apollo'
import upsertCommentAndSessionNotificationSubscriptionMutation from 'shared/graphql/upsertCommentAndSessionNotificationSubscription.gql'
import querySession from 'shared/graphql/querySession.gql'

export default function upsertCommentAndSessionNotificationSubscription({comment, userId}) {
	const {id, sessionId, content} = comment

	return apolloClient.mutate({
		mutation: upsertCommentAndSessionNotificationSubscriptionMutation,
		variables: {
			comment: {id, sessionId, content},
			userId,
			sessionId,
		},
		update(cache, response) {
			const result = response.data
			if (!result.insert_comments_one) {
				throw new Error(`Insertion of new comment was not possible.`)
			}

			const variables = {id: sessionId, userId, isUserAuthenticated: true, isUserWorkspaceMember: true}
			let data = cache.readQuery({query: querySession, variables})
			if (!data) return

			// update notification subscription status
			data = JSON.parse(JSON.stringify(data))
			data.session.notificationSubscriptions = [result.insert_session_notification_subscriptions_one]

			// update of an existing comment
			if (id) {
				const commentIndex = data.session.comments.indexOf(comment => comment.id === id)
				data.session.comments[commentIndex] = result.insert_comments_one

				return cache.writeQuery({query: querySession, variables, data})
			}

			// insert of a new comment
			if (!data.session.comments.find(comment => comment.id === result.insert_comments_one.id)) {
				// the new comment is not yet in the cache (could have hapened if the subscription kicked-in in between)
				data.session.comments.push(result.insert_comments_one)
			}

			cache.writeQuery({query: querySession, variables, data})
		},
	})
}
